import { TranslateService } from 'ng2-translate';

// Display open winnumber to table
export function displayIssue(num: any, translate: TranslateService,lotteryId?: any, methodId?: any) {
    console.log('translate',translate);
    
    if ( num.length <= 0 ) return;
    let tempStr = '';
    let htmlRow = '';
    let lotteryID = parseInt(lotteryId);
    let methodID = parseInt(methodId);

    if ( lotteryID && (
        // lotteryID === 200 || lotteryID === 201 ||
         lotteryID === 300 || lotteryID === 304 || lotteryID === 305
        || lotteryID === 402) ) { // result Mien Bac
        for (let i = 0, len = num.length; i < len; i++) {
            let numSeparate = separateNum(lotteryID, methodID, num[i], i);
            if ( i === 0 ) { // dac biet
                htmlRow += '<tr><td>' + translate.instant('SPECIAL_PRIZE') + '</td><td><div>'+numSeparate+'</div></td></tr>';
            }else if ( i === 1) { // nhat
                htmlRow += '<tr><td>' + translate.instant('FIRST_PRIZE') + '</td><td><div>'+numSeparate+'</div></td></tr>';
            }else if ( i === 2 || i === 3) { // nhi
                tempStr += '<div>'+numSeparate+'</div>';
                if ( i < 3 ) {
                    tempStr += ' - ';
                }
                if ( i === 3 ) {
                    htmlRow += '<tr><td>' + translate.instant('SECOND_PRIZE') + '</td><td>'+tempStr+'</td></tr>';
                    tempStr = ''; // reset tempStr
                }
            }else if ( i >= 4 && i <= 9 ) { // ba
                tempStr += '<div>'+numSeparate+'</div>';
                if ( i < 9 ) {
                    tempStr += ' - ';
                }
                if ( i === 9 ) {
                    htmlRow += '<tr><td>' + translate.instant('THIRD_PRIZE') + '</td><td>'+tempStr+'</td></tr>';
                    tempStr = ''; // reset tempStr
                }

            }else if ( i >= 10 && i <= 13 ) { // tu
                tempStr += '<div>'+numSeparate+'</div>';
                if ( i < 13 ) {
                    tempStr += ' - ';
                }
                if ( i === 13 ) {
                    htmlRow += '<tr><td>' + translate.instant('FOURTH_PRIZE') + '</td><td>'+tempStr+'</td></tr>';
                    tempStr = ''; // reset tempStr
                }
            }else if ( i >= 14 && i <= 19 ) { // nam
                tempStr += '<div>'+numSeparate+'</div>';
                if ( i < 19 ) {
                    tempStr += ' - ';
                }
                if ( i === 19 ) {
                    htmlRow += '<tr><td>' + translate.instant('FIFTH_PRIZE') + '</td><td>'+tempStr+'</td></tr>';
                    tempStr = ''; // reset tempStr
                }
            }else if ( i >= 20 && i <= 22 ) { // sau
                tempStr += '<div>'+numSeparate+'</div>';
                if ( i < 22 ) {
                    tempStr += ' - ';
                }
                if ( i === 22 ) {
                    htmlRow += '<tr><td>' + translate.instant('SIXTH_PRIZE') + '</td><td>'+tempStr+'</td></tr>';
                    tempStr = ''; // reset tempStr
                }
            }else if ( i >= 23 && i <= 26 ) { // bay
                tempStr += '<div>'+numSeparate+'</div>';
                if ( i < 26 ) {
                    tempStr += ' - ';
                }
                if ( i === 26 ) {
                    htmlRow += '<tr><td>' + translate.instant('SEVENTH_PRIZE') + '</td><td>'+tempStr+'</td></tr>';
                    tempStr = ''; // reset tempStr
                }
            }
        }
    }else {
        for (let i = 0, len = num.length; i < len; i++) {
            let numSeparate = separateNum(lotteryID, methodID, num[i], i);

            if ( i === 0 ) { // dac biet
                htmlRow += '<tr><td>' + translate.instant('SPECIAL_PRIZE') + '</td><td><div>'+numSeparate+'</div></td></tr>';
            }else if ( i === 1) { // nhat
                htmlRow += '<tr><td>' + translate.instant('FIRST_PRIZE') + '</td><td><div>'+numSeparate+'</div></td></tr>';
            }else if ( i === 2) { // nhi
                htmlRow += '<tr><td>' + translate.instant('SECOND_PRIZE') + '</td><td><div>'+numSeparate+'</div></td></tr>';
            }else if ( i === 3 || i === 4 ) { // ba
                tempStr += '<div>'+numSeparate+'</div>';
                if ( i < 4 ) {
                    tempStr += ' - ';
                }
                if ( i === 4 ) {
                    htmlRow += '<tr><td>' + translate.instant('THIRD_PRIZE') + '</td><td>'+tempStr+'</td></tr>';
                    tempStr = ''; // reset tempStr
                }

            }else if ( i >= 5 && i <= 11) { // tu
                tempStr += '<div>'+numSeparate+'</div>';
                if ( i < 11 ) {
                    tempStr += ' - ';
                }
                if ( i === 11 ) {
                    htmlRow += '<tr><td>' + translate.instant('FOURTH_PRIZE') + '</td><td>'+tempStr+'</td></tr>';
                    tempStr = ''; // reset tempStr
                }
            }else if ( i === 12) { // nam
                htmlRow += '<tr><td>' + translate.instant('FIFTH_PRIZE') + '</td><td><div>'+numSeparate+'</div></td></tr>';
            }else if ( i >= 13 && i <= 15) { // sau
                tempStr += '<div>'+numSeparate+'</div>';
                if ( i < 15 ) {
                    tempStr += ' - ';
                }
                if ( i === 15 ) {
                    htmlRow += '<tr><td>' + translate.instant('SIXTH_PRIZE') + '</td><td>'+tempStr+'</td></tr>';
                    tempStr = ''; // reset tempStr
                }
            }else if ( i === 16) { // bay
                htmlRow += '<tr><td>' + translate.instant('SEVENTH_PRIZE') + '</td><td><div>'+numSeparate+'</div></td></tr>';
            }else if ( i === 17) { // tam
                htmlRow += '<tr><td>' + translate.instant('EIGHTH_PRIZE') + '</td><td><div>'+numSeparate+'</div></td></tr>';
            }
        }
    }

    return '<table class="tblResultLottery">'+htmlRow+'</table>';
}

function appendDigits(digits: number, str: string, index?: number ) {
    let html = '';
    if ( typeof(index) !== 'undefined' ) {
        let arr = str.split(''),
            getIdxVal = arr[ arr.length - index ]
        html = '<span class="num__hightlight">' + getIdxVal + '</span>';
        arr[ arr.length - index ] = html;
        return arr.join('');
    }
    if (str.length >= digits) {
        let getDigit = str.substr(-digits);
        let getRecentDigit = str.substring( 0, str.length - digits );
        html = getRecentDigit + '<span class="num__hightlight">' + getDigit + '</span>';
    }else {
        html = str;
    }
    return html;
}

function separateNum( lotteryID, methodID, num, idx ) {
    let numSeparated = num;
    if ( lotteryID !== 200 && lotteryID !== 201  && lotteryID !== 300 && lotteryID !== 304 && lotteryID !== 305
        && lotteryID !== 402) {
        if ( [1, 14, 3, 4, 5, 16, 17, 18, 27, 29, 31].filter(x => x === methodID).length > 0 ) { // 2 digits
            numSeparated = appendDigits(2, num);
        }else if ( [2, 15].filter(x => x === methodID).length > 0 ) { // 3 digits
            if ( num.length > 2 ) {
                numSeparated = appendDigits(3, num);
            }
        }else if ( methodID === 7 && idx === 17 ) { // de dau
            numSeparated = appendDigits(2, num);
        }else if ( methodID === 6 && idx === 0 ) { // de dac biet
            numSeparated = appendDigits(2, num);
        }else if ( methodID === 8 && (idx === 17 || idx === 0) ) { // de dau duoi
            numSeparated = appendDigits(2, num);
        }else if ( [9, 20].filter(x => x === methodID).length > 0 && idx === 0 ) { // dau
            numSeparated = appendDigits(0, num, 2);
        }else if ( [10, 22].filter(x => x === methodID).length > 0 && idx === 0 ) { // duoi
            numSeparated = appendDigits(0, num, 1);
        }else if ( methodID === 11 && idx === 16 ) { // 3 cang dau
            numSeparated = appendDigits(3, num);
        }else if ( [12, 21].filter(x => x === methodID).length > 0 && idx === 0 ) { // 3 cang dac biet
            numSeparated = appendDigits(3, num);
        }else if ( methodID === 13 && (idx === 0 || idx === 16) ) { // 3 cang dau duoi
            numSeparated = appendDigits(3, num);
        }else if ( methodID === 25 ) { // lo 4 so
            numSeparated = appendDigits(4, num);
        }else if ( methodID === 24 && idx === 0 ) { // lo 4 cang dac biet
            numSeparated = appendDigits(4, num);
        }
    }else if (lotteryID === 200 || lotteryID === 201  || lotteryID === 300 || lotteryID === 304 || lotteryID === 305
        || lotteryID === 402) {
        if ( [1, 14, 3, 4, 5, 16, 17, 18, 28, 30, 32].filter(x => x === methodID).length > 0 ) { // 2 digits
            numSeparated = appendDigits(2, num);
        }else if ( [2, 15].filter(x => x === methodID).length > 0 ) { // 3 digits
            if ( num.length > 2 ) {
                numSeparated = appendDigits(3, num);
            }
        }else if ( (methodID === 6 || methodID === 1000) && idx === 0 ) { // de dac biet
            numSeparated = appendDigits(2, num);
        }else if ( [9, 20].filter(x => x === methodID).length > 0 && idx === 0 ) { // dau
            numSeparated = appendDigits(0, num, 2);
        }else if ( [10, 22].filter(x => x === methodID).length > 0 && idx === 0 ) { // duoi
            numSeparated = appendDigits(0, num, 1);
        }else if ( [12, 21].filter(x => x === methodID).length > 0 && idx === 0 ) { // 3 cang dac biet
            numSeparated = appendDigits(3, num);
        }else if ( methodID === 26 ) { // lo 4 so
            numSeparated = appendDigits(4, num);
        }else if ( methodID === 23 && idx === 0 ) { // lo 4 cang dac biet
            numSeparated = appendDigits(4, num);
        }
    }

    return numSeparated;
}

export function tblResultAll(num: any, lotteryId: any, translate: TranslateService) {
    if ( num.length <= 0 ) return;
    let tempStr = '';
    let htmlRow = '';
    let lotteryID = parseInt(lotteryId);

    if ( lotteryID && (lotteryID === 200 || lotteryID === 201 || lotteryID === 300 || lotteryID === 304 || lotteryID === 305
        || lotteryID === 402
      ) ) { // result Mien Bac
        for (let i = 0, len = num.length; i < len; i++) {
            let numSeparate = num[i];
            if ( i === 0 ) { // dac biet
                htmlRow += '<tr><td>' + translate.instant('SPECIAL_PRIZE') + '</td><td><div>'+numSeparate+'</div></td></tr>';
            }else if ( i === 1) { // nhat
                htmlRow += '<tr><td>' + translate.instant('FIRST_PRIZE') + '</td><td><div>'+numSeparate+'</div></td></tr>';
            }else if ( i === 2 || i === 3) { // nhi
                tempStr += '<div>'+numSeparate+'</div>';
                if ( i < 3 ) {
                    tempStr += ' - ';
                }
                if ( i === 3 ) {
                    htmlRow += '<tr><td>' + translate.instant('SECOND_PRIZE') + '</td><td>'+tempStr+'</td></tr>';
                    tempStr = ''; // reset tempStr
                }
            }else if ( i >= 4 && i <= 9 ) { // ba
                tempStr += '<div>'+numSeparate+'</div>';
                if ( i < 9 ) {
                    tempStr += ' - ';
                }
                if ( i === 9 ) {
                    htmlRow += '<tr><td>' + translate.instant('THIRD_PRIZE') + '</td><td>'+tempStr+'</td></tr>';
                    tempStr = ''; // reset tempStr
                }

            }else if ( i >= 10 && i <= 13 ) { // tu
                tempStr += '<div>'+numSeparate+'</div>';
                if ( i < 13 ) {
                    tempStr += ' - ';
                }
                if ( i === 13 ) {
                    htmlRow += '<tr><td>' + translate.instant('FOURTH_PRIZE') + '</td><td>'+tempStr+'</td></tr>';
                    tempStr = ''; // reset tempStr
                }
            }else if ( i >= 14 && i <= 19 ) { // nam
                tempStr += '<div>'+numSeparate+'</div>';
                if ( i < 19 ) {
                    tempStr += ' - ';
                }
                if ( i === 19 ) {
                    htmlRow += '<tr><td>' + translate.instant('FIFTH_PRIZE') + '</td><td>'+tempStr+'</td></tr>';
                    tempStr = ''; // reset tempStr
                }
            }else if ( i >= 20 && i <= 22 ) { // sau
                tempStr += '<div>'+numSeparate+'</div>';
                if ( i < 22 ) {
                    tempStr += ' - ';
                }
                if ( i === 22 ) {
                    htmlRow += '<tr><td>' + translate.instant('SIXTH_PRIZE') + '</td><td>'+tempStr+'</td></tr>';
                    tempStr = ''; // reset tempStr
                }
            }else if ( i >= 23 && i <= 26 ) { // bay
                tempStr += '<div>'+numSeparate+'</div>';
                if ( i < 26 ) {
                    tempStr += ' - ';
                }
                if ( i === 26 ) {
                    htmlRow += '<tr><td>' + translate.instant('SEVENTH_PRIZE') + '</td><td>'+tempStr+'</td></tr>';
                    tempStr = ''; // reset tempStr
                }
            }
        }
    }else {
        for (let i = 0, len = num.length; i < len; i++) {
            let numSeparate = num[i];
            if ( i === 0 ) { // dac biet
                htmlRow += '<tr><td>' + translate.instant('SPECIAL_PRIZE') + '</td><td><div>'+numSeparate+'</div></td></tr>';
            }else if ( i === 1) { // nhat
                htmlRow += '<tr><td>' + translate.instant('FIRST_PRIZE') + '</td><td><div>'+numSeparate+'</div></td></tr>';
            }else if ( i === 2) { // nhi
                htmlRow += '<tr><td>' + translate.instant('SECOND_PRIZE') + '</td><td><div>'+numSeparate+'</div></td></tr>';
            }else if ( i === 3 || i === 4 ) { // ba
                tempStr += '<div>'+numSeparate+'</div>';
                if ( i < 4 ) {
                    tempStr += ' - ';
                }
                if ( i === 4 ) {
                    htmlRow += '<tr><td>' + translate.instant('THIRD_PRIZE') + '</td><td>'+tempStr+'</td></tr>';
                    tempStr = ''; // reset tempStr
                }

            }else if ( i >= 5 && i <= 11) { // tu
                tempStr += '<div>'+numSeparate+'</div>';
                if ( i < 11 ) {
                    tempStr += ' - ';
                }
                if ( i === 11 ) {
                    htmlRow += '<tr><td>' + translate.instant('FOURTH_PRIZE') + '</td><td>'+tempStr+'</td></tr>';
                    tempStr = ''; // reset tempStr
                }
            }else if ( i === 12) { // nam
                htmlRow += '<tr><td>' + translate.instant('FIFTH_PRIZE') + '</td><td><div>'+numSeparate+'</div></td></tr>';
            }else if ( i >= 13 && i <= 15) { // sau
                tempStr += '<div>'+numSeparate+'</div>';
                if ( i < 15 ) {
                    tempStr += ' - ';
                }
                if ( i === 15 ) {
                    htmlRow += '<tr><td>' + translate.instant('SIXTH_PRIZE') + '</td><td>'+tempStr+'</td></tr>';
                    tempStr = ''; // reset tempStr
                }
            }else if ( i === 16) { // bay
                htmlRow += '<tr><td>' + translate.instant('SEVENTH_PRIZE') + '</td><td><div>'+numSeparate+'</div></td></tr>';
            }else if ( i === 17) { // tam
                htmlRow += '<tr><td>' + translate.instant('EIGHTH_PRIZE') + '</td><td><div>'+numSeparate+'</div></td></tr>';
            }
        }
    }

    return '<table>'+htmlRow+'</table>';
}

export function separateType(arrNum: any, type: number, translate: TranslateService) {
    let arrTwoLastDigit = [];
    let arrGet = [];
    let htmlRow = '';
    for (let i = 0, len = arrNum.length; i < len; i++) {
        let getDigit = arrNum[i].substr(-2);
        arrTwoLastDigit.push(getDigit);
    }
    if (type === 0) {
        htmlRow += '<tr class="title"><td><span class="font-500">' + translate.instant('HEAD') + '</span></td><td><span class="font-500">' + translate.instant('TAIL') + '</span></td></tr>';
    }else if (type === 1) {
        htmlRow += '<tr class="title"><td><span class="font-500">' + translate.instant('TAIL') + '</span></td><td><span class="font-500">' + translate.instant('HEAD') + '</span></td></tr>';
    }

    for (let i = 0; i < 10; i++) {
        arrGet[i] = [];
        for (let j = 0, len = arrTwoLastDigit.length; j < len; j++) {
            let getFistNum = Number(arrTwoLastDigit[j].split('')[0]);
            let getLastNum = Number(arrTwoLastDigit[j].split('')[1]);
            if ( i === getFistNum && type === 0) {
                arrGet[i].push(getLastNum);
            }else if ( i === getLastNum && type === 1) {
                arrGet[i].push(getFistNum);
            }
        }
        htmlRow += '<tr><td>'+i+'</td><td>'+arrGet[i].join(', ')+'</td></tr>';
    }

    return '<table class="tblDauDuoi">'+htmlRow+'</table>';
}

export function checkGameTaiXiu(lotteryID) {
    if (Number(lotteryID) === 60 || Number(lotteryID) === 80) return true;
    else return false;
}

export function checkGameXocDia(lotteryID) {
    if (Number(lotteryID) === 90 || Number(lotteryID) === 91) return true;
    else return false;
}


// WEBPACK FOOTER //
// ./src/directives/common.ts